import { render, staticRenderFns } from "./TravelBasicInfo.vue?vue&type=template&id=4d3310d2&scoped=true"
import script from "./TravelBasicInfo.vue?vue&type=script&lang=js"
export * from "./TravelBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./TravelBasicInfo.vue?vue&type=style&index=0&id=4d3310d2&prod&lang=less&scoped=true"
import style1 from "./TravelBasicInfo.vue?vue&type=style&index=1&id=4d3310d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3310d2",
  null
  
)

export default component.exports